import { SHAPE_TYPE } from "./../ricos-content/index.js";
import { DEFAULTS } from "./utils/consts.js";
import { nodeViewRenderers } from "./viewer/node-view-renderers-lazy.js";
const pluginShape = (config) => {
  return {
    config: { ...DEFAULTS.config, ...config },
    type: SHAPE_TYPE,
    nodeViewRenderers
  };
};
export {
  pluginShape
};
//# sourceMappingURL=viewer-lazy.js.map
